import { all, call } from 'redux-saga/effects';

import addPartner from './addPartner';
import getCouple from './getCouple';

export function* coupleSagas() {
  yield all([getCouple, addPartner].map(call));
}
